<!DOCTYPE html>
<html lang="en" data-app-version="%VITE_GIT_REV%">
  <head gtag-measurement-id="G-KXRDB45WFK">
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta name="description" content="Distributive Portal: Manage your DCP Jobs, Workers, and Compute Credits">
    <link rel="manifest" href="/manifest.json?%VITE_GIT_REV%" />
    <link rel="stylesheet" href="%VITE_DCP_CDN_ORIGIN%/css/dcp-style-branded.css?cache-key=%VITE_DCP_CACHE_KEY%">
    <script type="module" src="%VITE_DCP_CDN_ORIGIN%/dcp-dom-tk.js?cache-key=%VITE_DCP_CACHE_KEY%"></script>
    <script type="module" src="%VITE_DCP_CDN_ORIGIN%/components/gdpr-gtag.js?cache-key=%VITE_DCP_CACHE_KEY%"></script>
    <script>
      /* dcp-client did not load => mid-server-refresh */
      function dcpClientErrorCallback()
      {
        console.error('dcp-client did not load - reloading page');
        setTimeout(() => window.location.reload(), 200 + (2000 * Math.random()));
      }

      function dcpClientReadyCallback()
      {
        /* If this page is loaded from an unbranded URL, redirect to the default brand. Specifically to
         * portal.distributed.computer redirect to dcp.cloud, but generic enough that it should be possible
         * to test this in staging.
         */
        if (dcpConfig.portal.brandBase
            && (dcpConfig.portal.brandBase.origin !== dcpConfig.portal.location.origin)
            && (!window.location.hostname.endsWith(dcpConfig.portal.brandBase.hostname)))
          dcp['dom-tk'].modals.withMutex().then(() => window.location.href = dcpConfig.portal.brandBase.href);
      }
    </script>
    <script src="%VITE_DCP_SCHEDULER_LOCATION%/dcp-client/dcp-client.js?cache-key=%VITE_DCP_CACHE_KEY%"
            scheduler="%VITE_DCP_SCHEDULER_LOCATION%"
            dcp-config.o-auth.client-id="string:%VITE_OAUTH_CLIENTID%"
            onready="dcpClientReadyCallback()"
            onerror="dcpClientErrorCallback()"
            dcp-config.worker.cores="number:1">
    </script>
    <link rel="apple-touch-icon" href="%VITE_ASSETS_PATH%/img/logo192.png?%VITE_GIT_REV%" />
    <!--
      manifest.json provides metadata used when your web app is installed on a
      user's mobile device or desktop. See https://developers.google.com/web/fundamentals/web-app-manifest/
    -->
    <link rel="manifest" href="/manifest.json?%VITE_GIT_REV%" />

    <title>DCP Portal</title>
    <script>
      /* Set auth directive to indicate desire to logout and reset local PCKE state, processed in main.jsx after redirects */
      switch (window.location.hash)
      {
        case '#logout':
          sessionStorage.setItem('auth-directive', 'logout');
          break;
        case '#test-features':
          sessionStorage.setItem('test-features', true);
          break;
      }
    </script>

    <!-- Entrypoint to render React SPA. -->
    <script type="module" src="/src/main.jsx"></script>

    <script type="module">
/* Remove no-longer-supported localStorage info */
const self = sessionStorage.getItem('identity');
if (self)
{
  const selfStorageJSON = localStorage.getItem(self);
  if (selfStorageJSON)
  {
    const selfStorage = JSON.parse(selfStorageJSON);
    if (selfStorage.workerPaymentAccount)
    {
      const workerPaymentAccountSafe = {
        dbKey:   selfStorage.workerPaymentAccount.dbKey,
        address: selfStorage.workerPaymentAccount.address,
        label:   selfStorage.workerPaymentAccount.label,
      };
      selfStorage.workerPaymentAccount = workerPaymentAccountSafe;
    }
    localStorage.setItem(self, JSON.stringify(selfStorage));
  }
  sessionStorage.removeItem('identity');
}
    </script>
    <link rel="icon" href="%VITE_ASSETS_PATH%/icons/favicon.ico?%VITE_GIT_REV%" />
  </head>
  <body>
    <!-- Load brand/skin styles after SPA styles. -->
    <link rel="stylesheet" href="%VITE_ASSETS_PATH%/branding.css?%VITE_GIT_REV%" />
    <noscript>You need to enable JavaScript to use the DCP Portal.</noscript>
    <div id="root"></div>
    <a id="downloadLink"></a>
    <script type="module">
      if (sessionStorage.getItem('test-features'))
        document.body.setAttribute('test-features', 'enabled');
    </script>
    <script type="module" src="/dcpdbg.js?cache-key=%VITE_DCP_CACHE_KEY%"></script>
  </body>
</html>
